export * from "modules/HoldingAppointmentDetails/components/Checks/components/Check/components/QuestionResults/components/QuestionResult";
export * from "modules/HoldingAppointmentDetails/components/Checks/components/Check/components/QuestionResults/components/QuestionResultMedia";
